import CardReaderView from './CardReaderView';

export default CardReaderView;
